export const OpportunityTypes = Object.freeze({
    INVOICE_DISCOUNTING: 'InvoiceDiscounting',
    ASSET_BACKED_LEASING: 'AssetBackedLeasing',
    TREASURY_BILL: 'TreasuryBill',
    VENTURE_DEBT: 'VentureDebt',
    CORPORATE_DEBT: 'CorporateDebt',
});
